import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function SitterTermsPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const articles = [
    {
      title: '第1条（適用）',
      content: ['本規約は、PawBridgeに登録するペットシッター（以下「シッター」）の利用条件を定めるものです。'],
    },
    {
      title: '第2条（サービス提供責任）',
      content: ['シッターは、自らの責任においてペットシッティングサービスを提供するものとします。'],
    },
    {
      title: '第3条（登録条件）',
      content: ['シッターは以下を満たす必要があります。'],
      bullets: ['正確な個人情報の提供', '動物を安全に扱える能力', '適切なコミュニケーション能力'],
    },
    {
      title: '第4条（義務）',
      content: ['シッターは以下を遵守するものとします。'],
      bullets: ['ペットの安全確保', '飼い主の指示の遵守', '緊急時の適切な対応', '誠実な対応'],
    },
    {
      title: '第5条（禁止事項）',
      content: ['シッターは以下を行ってはなりません。'],
      bullets: ['虐待または不適切な扱い', '無断キャンセル', '虚偽情報の掲載', 'プラットフォーム外取引への誘導'],
    },
    {
      title: '第6条（報酬）',
      content: ['シッターは、予約料金から当社所定の手数料（20%）を差し引いた金額を受け取ります。'],
    },
    {
      title: '第7条（支払い）',
      content: ['報酬は当社が指定する決済システムを通じて支払われます。'],
    },
    {
      title: '第8条（保険および責任）',
      content: ['シッターは、自身の責任において必要に応じた保険に加入するものとします。'],
    },
    {
      title: '第9条（事故対応）',
      content: ['事故が発生した場合、シッターは速やかに飼い主および当社へ報告し、適切な対応を行うものとします。'],
    },
    {
      title: '第10条（評価）',
      content: ['シッターは、利用者からの評価の対象となります。'],
    },
    {
      title: '第11条（アカウント停止）',
      content: ['当社は、規約違反または不適切な行為があった場合、シッターの登録を停止または削除できるものとします。'],
    },
    {
      title: '第12条（責任の範囲）',
      content: ['シッターは、提供したサービスに関する責任を負うものとします。'],
    },
    {
      title: '第13条（規約の変更）',
      content: ['当社は必要に応じて本規約を変更することができます。'],
    },
  ];

  return (
    <div className="min-h-screen bg-[#EEF4F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#81D8D0]/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-24 sm:h-28">
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="w-40 h-40 sm:w-48 sm:h-48 object-contain brightness-0"
              />
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link to="/sitters" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                シッターを探す
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/sitter-registration" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                シッター登録
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/login" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                ログイン
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/booking" className="px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-medium rounded-full hover:bg-white/90 transition-all hover:shadow-lg whitespace-nowrap">
                予約する
              </Link>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <Link to="/sitters" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッターを探す</Link>
              <Link to="/sitter-registration" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッター登録</Link>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">ログイン</Link>
              <Link to="/booking" onClick={() => setMobileMenuOpen(false)} className="block px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-medium rounded-full hover:bg-white/90 transition-all text-center">予約する</Link>
            </div>
          )}
        </div>
      </nav>

      <div className="pt-28 sm:pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          {/* Header */}
          <div className="mb-8 md:mb-12">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#81D8D0]/20">
                <i className="ri-user-heart-line text-xl text-[#81D8D0]"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-[#1B2A4A]">PawBridge シッター利用規約</h1>
            </div>
            <p className="text-xs md:text-sm text-[#1B2A4A]/50">最終更新日：2026年3月29日</p>
          </div>

          {/* Key points */}
          <div className="grid sm:grid-cols-3 gap-4 mb-8">
            {[
              { icon: 'ri-user-settings-line', label: '独立した事業者', sub: 'PawBridgeの従業員ではなく、独立したサービス提供者として活動します' },
              { icon: 'ri-percent-line', label: '手数料 20%', sub: '予約料金から当社所定の手数料を差し引いた金額を受け取ります' },
              { icon: 'ri-alarm-warning-line', label: '事故時は即報告', sub: '事故発生後は速やかに飼い主および当社へ報告してください' },
            ].map(card => (
              <div key={card.label} className="bg-[#81D8D0]/10 border border-[#81D8D0]/30 rounded-xl p-4 flex gap-3 items-start">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#81D8D0]/20 flex-shrink-0">
                  <i className={`${card.icon} text-lg text-[#81D8D0]`}></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-[#1B2A4A]">{card.label}</p>
                  <p className="text-xs text-[#1B2A4A]/60 leading-relaxed mt-0.5">{card.sub}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Articles */}
          <div className="bg-white rounded-2xl p-4 md:p-8 shadow-sm space-y-6 md:space-y-8">
            {articles.map((article, i) => (
              <section key={i} className={i > 0 ? 'border-t border-[#D4E8EC] pt-6 md:pt-8' : ''}>
                <h2 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-3 md:mb-4">{article.title}</h2>
                <div className="space-y-2 md:space-y-3 text-sm md:text-base text-[#1B2A4A]/80 leading-relaxed">
                  {article.content.map((p, j) => <p key={j}>{p}</p>)}
                  {'bullets' in article && article.bullets && (
                    <ul className="list-disc list-inside space-y-1.5 md:space-y-2 ml-2 md:ml-4">
                      {article.bullets.map((item, j) => <li key={j}>{item}</li>)}
                    </ul>
                  )}
                </div>
              </section>
            ))}

            {/* Platform outside trade warning */}
            <section className="border-t border-[#D4E8EC] pt-6 md:pt-8">
              <div className="bg-red-50 border border-red-200 rounded-xl p-4 md:p-5">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-error-warning-line text-red-500 text-lg"></i>
                  <p className="text-sm font-bold text-red-700">プラットフォーム外取引の厳禁</p>
                </div>
                <p className="text-xs md:text-sm text-red-700/80 leading-relaxed mb-2">
                  PawBridgeを通じて知り合った飼い主との取引は、必ずプラットフォーム内で完結させてください。外部SNS・直接連絡先の交換・プラットフォーム外での決済は厳重に禁止されています。
                </p>
                <p className="text-xs text-red-600 font-semibold">違反が発覚した場合、アカウントの停止・削除および法的措置を含む厳正な対処を行います。</p>
              </div>
            </section>

            {/* Contact */}
            <section className="border-t border-[#D4E8EC] pt-6 md:pt-8">
              <h2 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-3 md:mb-4">お問い合わせ</h2>
              <p className="text-sm md:text-base text-[#1B2A4A]/80 leading-relaxed">
                本規約に関するお問い合わせは、本サービス内のお問い合わせフォームからご連絡ください。
              </p>
            </section>
          </div>

          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/sitter-registration" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              シッター登録に戻る
            </Link>
            <span className="hidden sm:block text-[#1B2A4A]/30">|</span>
            <Link to="/terms" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              利用規約を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
            <span className="hidden sm:block text-[#1B2A4A]/30">|</span>
            <Link to="/guarantee" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              安心保証規約を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#81D8D0] text-white pt-12 md:pt-20 pb-8 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="h-28 md:h-36 mb-4 md:mb-5 brightness-0"
              />
              <p className="text-xs md:text-sm text-white/80 leading-relaxed">海外在住日本人のためのペットシッターコミュニティ</p>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">サービス</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/sitters" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター検索</Link></li>
                <li><Link to="/sitter-registration" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター登録</Link></li>
                <li><Link to="/booking" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">料金</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">会社情報</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/about" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridgeについて</Link></li>
                <li><Link to="/contact" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">お問い合わせ</Link></li>
                <li><Link to="/terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 利用規約</Link></li>
                <li><Link to="/sitter-terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge シッター利用規約</Link></li>
                <li><Link to="/guarantee" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 安心保証規約</Link></li>
                <li><Link to="/privacy" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">プライバシーポリシー</Link></li>
              </ul>
            </div>
          </div>
          <div className="pt-6 md:pt-8 border-t border-white/30 text-center">
            <p className="text-xs text-white/70">© 2025 PawBridge. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
